var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('DonationHeader'),_c('DonationIntro'),_c('DonationBullets'),_c('DonationHow'),_c('DonationMore')],1)}
var staticRenderFns = []

export { render, staticRenderFns }